export enum SegmentType {
  Business = 'Business',
  Consumer = 'Consumer',
  Convergence = 'Convergence',
  Unknown = '',
}
